import type { DxTradeOrderType } from '@model/DxTrade.types'

export enum DxtradeOrderHistoryFields {
  InStatus = 'in-status',
  Side = 'side',
  OfType = 'of-type',
  IssuedFrom = 'issued-from',
  IssuedTo = 'issued-to',
  WithOrderId = 'with-order-id',
  PositionEffect = 'position-effect',
  PageIndex = 'pageIndex',
  PageSize = 'pageSize',
}

export interface DxtradeOrdersHistoryQuery {
  status?: string
  side?: string
  ofType?: DxTradeOrderType
  issuedFrom?: string
  issuedTo?: string
  withOrderIds?: string | Array<string>
  positionEffect?: 'OPEN' | 'CLOSE'
}

export function prepareDxtradeOrdersHistoryParams(
  query?: DxtradeOrdersHistoryQuery
): URLSearchParams {
  const params = new URLSearchParams()
  if (!query) return params
  if (query.status) {
    if (query.status.toUpperCase() === 'WORKING') {
      params.set(DxtradeOrderHistoryFields.InStatus, 'WORKING')
    } else if (query.status.toUpperCase() === 'COMPLETED') {
      params.set(DxtradeOrderHistoryFields.InStatus, 'COMPLETED')
    }
  }
  if (query.side) params.set(DxtradeOrderHistoryFields.Side, query.side)
  if (query.ofType) params.set(DxtradeOrderHistoryFields.OfType, query.ofType)
  if (query.positionEffect) {
    params.set(DxtradeOrderHistoryFields.PositionEffect, query.positionEffect)
  }
  if (query.issuedFrom) params.set(DxtradeOrderHistoryFields.IssuedFrom, query.issuedFrom)
  if (query.issuedTo) params.set(DxtradeOrderHistoryFields.IssuedTo, query.issuedTo)
  if (query.withOrderIds != null) {
    const ids = Array.isArray(query.withOrderIds) ? query.withOrderIds : [query.withOrderIds]

    for (const id of ids) {
      params.append(DxtradeOrderHistoryFields.WithOrderId, id)
    }
  }
  return params
}
